import React, { useState } from "react";
import styles from "./JapanTable.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

const regions = [
  [
    { area: "sea", col: "14", row: "3" },
    { col: "2", area: "hokkaidou", value: "北海道", label: "北海道" },
  ],
  [{ col: "2", area: "tohoku", value: "青森県", label: "青森" }],
  [
    { area: "tohoku", value: "秋田県", label: "秋田" },
    { area: "tohoku", value: "岩手県", label: "岩手" },
  ],
  [
    { area: "sea", col: "10" },
    { row: "2", area: "chubu", value: "石川県", label: "石川" },
    { area: "sea", col: "3" },
    { area: "tohoku", value: "山形県", label: "山形" },
    { area: "tohoku", value: "宮城県", label: "宮城" },
  ],
  [
    { area: "sea", col: "10" },
    { col: "2", area: "chubu", value: "富山県", label: "富山" },
    { col: "2", area: "chubu", value: "新潟県", label: "新潟" },
    { area: "tohoku", value: "福島県", label: "福島" },
  ],
  [
    { area: "sea", col: "9" },
    { col: "2", area: "chubu", value: "福井県", label: "福井" },
    { row: "2", area: "chubu", value: "岐阜県", label: "岐阜" },
    { row: "2", area: "chubu", value: "長野県", label: "長野" },
    { area: "kanto", value: "群馬県", label: "群馬" },
    { area: "kanto", value: "栃木県", label: "栃木" },
    { row: "2", area: "kanto", value: "茨城県", label: "茨城" },
  ],
  [
    { area: "sea", row: "2" },
    { row: "2", area: "kyushu", value: "長崎県", label: "長崎" },
    { col: "2", area: "kyushu", value: "福岡県", label: "福岡" },
    { area: "chugoku", value: "山口県", label: "山口" },
    { area: "chugoku", value: "島根県", label: "島根" },
    { area: "chugoku", value: "鳥取県", label: "鳥取" },
    { row: "2", area: "kinki", value: "兵庫県", label: "兵庫" },
    { area: "kinki", value: "京都府", label: "京都" },
    { col: "2", area: "kinki", value: "滋賀県", label: "滋賀" },
    { area: "chubu", value: "山梨県", label: "山梨" },
    { area: "kanto", value: "埼玉県", label: "埼玉" },
  ],
  [
    { area: "kyushu", value: "佐賀県", label: "佐賀" },
    { area: "kyushu", value: "大分県", label: "大分" },
    { area: "sea" },
    { area: "chugoku", value: "広島県", label: "広島" },
    { area: "chugoku", value: "岡山県", label: "岡山" },
    { area: "kinki", value: "大阪府", label: "大阪" },
    { area: "kinki", value: "奈良県", label: "奈良" },
    { row: "2", area: "kinki", value: "三重県", label: "三重" },
    { area: "chubu", value: "愛知県", label: "愛知" },
    { row: "2", area: "chubu", value: "静岡県", label: "静岡" },
    { row: "2", area: "kanto", value: "神奈川県", label: "神奈川" },
    { area: "kanto", value: "東京都", label: "東京" },
    { row: "2", area: "kanto", value: "千葉県", label: "千葉" },
  ],
  [
    { area: "sea", col: "2" },
    { area: "kyushu", value: "熊本県", label: "熊本" },
    { area: "kyushu", value: "宮崎県", label: "宮崎" },
    { area: "sea" },
    { area: "shikoku", value: "愛媛県", label: "愛媛" },
    { area: "shikoku", value: "香川県", label: "香川" },
    { area: "sea" },
    { col: "2", area: "kinki", value: "和歌山県", label: "和歌山" },
    { area: "sea" },
    { area: "sea" },
  ],
  [
    { area: "sea", col: "2" },
    { col: "2", area: "kyushu", value: "鹿児島県", label: "鹿児島" },
    { area: "sea" },
    { area: "shikoku", value: "高知県", label: "高知" },
    { area: "shikoku", value: "徳島県", label: "徳島" },
    { area: "sea", col: "9" },
  ],
  [{ area: "kyushu", value: "沖縄県", label: "沖縄" }, { area: "sea", col: "15" }],
];

const JapanTable = ({ onPrefectureSelect, onMapChange, activePrefecture }) => {

  const [activeId, setActiveId] = useState(null);

  function handleButtonClick(pref) {
    if (activeId === pref) {
      onPrefectureSelect([]);
      setActiveId(null);
      return;
    }
    onPrefectureSelect([pref]);
    setActiveId(pref);
  }

  function handleCloseClick() {
    onPrefectureSelect([]);
    setActiveId(null);
    onMapChange();
  }

  const renderButton = (region, index) => (
    <td
      key={index}
      colSpan={region.col}
      rowSpan={region.row}
      className={`${styles[region.area]} ${activeId === region.value ? styles.active : ''} ${activePrefecture.has(region.value) ? styles.have : styles.notHave }`}>
      {region.value && <button onClick={() => handleButtonClick(region.value)}>
        {region.label}
      </button>}
    </td>
  );

  return (
    <div className={styles.mapContainer}>
      <div className={styles.mapHeader}>
        <button onClick={handleCloseClick} className={styles.closeButton} aria-label="地図を閉じる">
          <FontAwesomeIcon icon={faClose} /> 閉じる
        </button>
      </div>
      <table className={styles.mapTable}>
        <tbody>
          {regions.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((region, index) => renderButton(region, index))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default JapanTable;
